import { useState } from 'react';
import craft from '~/assets/icons/craft.svg';
import { MenuTabs } from '~/components/ui/MenuTabs';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { SearchInput } from '~/components/ui/SearchInput';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { CraftItem } from '../CraftItem';
import {
	StyledContainer,
	StyledListContainer,
	StyledSearchContainer,
} from './CraftList.styled';

const CraftList = () => {
	const [activeTab, setActiveTab] = useState(0);
	const tabs = ['Все предметы', 'Рыбалка', 'Оружие'];

	const handlePrevTab = () => {
		setActiveTab((prev) => (prev === 0 ? 0 : prev - 1));
	};

	const handleNextTab = () => {
		setActiveTab((prev) => (prev === tabs.length - 1 ? prev : prev + 1));
	};

	return (
		<StyledContainer>
			<MenuTabs
				tabs={tabs}
				activeIndex={activeTab}
				handlePrev={handlePrevTab}
				handleNext={handleNextTab}
				setIndex={setActiveTab}
			/>
			<StyledSearchContainer>
				<SearchInput
					placeholder="Поиск"
					style={{ fontSize: 18, padding: '0 45px 0 15px' }}
				/>
			</StyledSearchContainer>
			<SectionHeading text="Доступные крафты" icon={craft} />
			<ScrollContainer width={380} height={408} style={{ marginTop: 20 }}>
				<StyledListContainer>
					{new Array(10).fill(0).map((_, index) => (
						<CraftItem
							key={index}
							itemId="maggots"
							title="Мясо червей"
							category="Рыбалка"
							active={index === 0}
							handleClick={() => {}}
						/>
					))}
				</StyledListContainer>
			</ScrollContainer>
		</StyledContainer>
	);
};

export { CraftList };
